var version$1;
var hasRequiredVersion$1;

function requireVersion$1 () {
	if (hasRequiredVersion$1) return version$1;
	hasRequiredVersion$1 = 1;
	version$1 = '2.1.8';
	return version$1;
}

export { requireVersion$1 as __require };
//# sourceMappingURL=version.js.map
